
const config = {
  development: {
    "upUrl": "",
    "sysmUrl": "",
    "fundmUrl": "",
    "btsmUrl": "",
    "exmUrl": "",
    "jxmUrl": "",
    "ecmUrl": "",
    "jcmUrl": "",
    "esmUrl": "",
    "emmUrl": "",
    "promUrl": "",
    "infom": "",
    "newUrl": 'https://devm.cjjy.com/cjjy-admin/#/home/welcome'
    // "newUrl":'http://localhost:5173/cjjy-admin/#/home/welcome'
    // "newUrl":'http://localhost:5173/cjjy-admin/#/login'
  },
  test: {
    "upUrl": "",
    "sysmUrl": "",
    "fundmUrl": "",
    "btsmUrl": "",
    "exmUrl": "",
    "jxmUrl": "",
    "ecmUrl": "",
    "jcmUrl": "",
    "esmUrl": "",
    "emmUrl": "",
    "promUrl": "",
    "infom": "",
    "newUrl": 'https://sitm.cjjy.com/cjjy-admin/#/home/welcome'
  },
  uat: {
    "upUrl": "",
    "sysmUrl": "",
    "fundmUrl": "",
    "btsmUrl": "",
    "exmUrl": "",
    "jxmUrl": "",
    "ecmUrl": "",
    "jcmUrl": "",
    "esmUrl": "",
    "emmUrl": "",
    "promUrl": "",
    "infom": "",
    "newUrl": 'https://uatm.cjjy.com/cjjy-admin/#/home/welcome'
  },
  production: {
    "upUrl": "",
    "sysmUrl": "",
    "fundmUrl": "",
    "btsmUrl": "",
    "exmUrl": "",
    "jxmUrl": "",
    "ecmUrl": "",
    "jcmUrl": "",
    "esmUrl": "",
    "emmUrl": "",
    "promUrl": "",
    "infom": "",
    "newUrl": 'https://manage.cjjy.com/cjjy-admin/#/home/welcome'
  }
}

export default config[process.env.NODE_ENV]


// WEBPACK FOOTER //
// ./src/config/index.js